import * as React from 'react';

// Contexts
import { AuthContext } from '../contexts/Auth';

// Types
import { IUserRole } from '../types';

export const usePermission = (acceptedRoles?: IUserRole[]) => {
    const permittedRoles = React.useMemo(() => {
        return !acceptedRoles
            ? [IUserRole.CIC_ADMIN, IUserRole.CIC_OWNER, IUserRole.CIC_USER, IUserRole.ORG_PRIMARY, IUserRole.ORG_USER]
            : acceptedRoles;
    }, [acceptedRoles]);
    const { authState } = React.useContext(AuthContext);
    const isPermitted = React.useMemo(() => {
        if (!authState?.initializing) {
            return authState?.roles?.some((role) => permittedRoles.includes(role));
        }
    }, [authState?.roles, authState, permittedRoles]);

    return isPermitted;
};

export default usePermission;
